"use client";
import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from "react";
import navLogo from '../../../assets/images/logo-nav-vertical-color.png';

const MobileMenu = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  const [isActive, setIsActive] = useState({
    status: false,
    key: "",
    subMenuKey: "",
  });

  const handleToggle = (key, subMenuKey = "") => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: "",
        subMenuKey: "",
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };
  return (
    <>
      {/*End Mobile Menu */}
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <Link to="/">
              <img src={navLogo} alt="" />
            </Link>
          </div>
          {/* /.logo-box */}
          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li>
                <Link to="/" onClick={handleMobileMenu}>
                  Cartelera
                </Link>
              </li>
              <li>
                <Link to="/home" onClick={handleMobileMenu}>
                  Inicio
                </Link>
              </li>
              {window.location.pathname === "/home" && (
                <li>
                  <a href='#th-team'>Talentos</a>
                </li>
              )}
              <li>
                <Link to="/contact" onClick={handleMobileMenu}>
                  Promociona con nosotros
                </Link>
              </li>
            </ul>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope" />
              <a href="mailto:comercial@ecueventos000.com ">
                comercial@ecueventos000.com
              </a>
            </li>
            <li>
              <i className="fa fa-phone-alt" />
              <a href="tel:(+593) 96 300 3755">(+593) 96 300 3755</a>
            </li>
            <li>
              <i className="fa fa-phone-alt" />
              <a href="tel:(+593) 98 310 7016">(+593) 98 310 7016</a>
            </li>
          </ul>
          {/* /.mobile-nav__contact */}
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <Link to="https://www.facebook.com/ecueventos000" target="_blank" className="fab fa-facebook-square" />
              <Link to="https://www.instagram.com/ecueventos000/" target="_blank" className="fab fa-instagram" />
              <Link to="https://chat.whatsapp.com/EwuN5XoUIGd9RR18PGxjjp" target="_blank" rel="noopener noreferrer" className="fab fa-whatsapp"></Link>
            </div>
            {/* /.mobile-nav__social */}
          </div>
          {/* /.mobile-nav__top */}
        </div>
        {/* /.mobile-nav__content */}
      </div>

      <div
        className="nav-overlay"
        style={{ display: `${isSidebar ? "block" : "none"}` }}
        onClick={handleSidebar}
      />
    </>
  );
};
export default MobileMenu;
